import React from "react";

import { WEEKLY_BUCKET_COLUMN_WIDTHS } from "./weeklyEACColumns";
import { formatCellValue } from "./weeklyEACFormat";
import { getBucketForWeek, round2 } from "./weeklyEACCalculations";

// Mirrors Detailed View's "Total Direct Labor Cost" row — Hours/Burden Cost summed across all
// employees per week; static columns and Eff. Cost Rate are left blank (not meaningful to sum).
export default function WeeklyEACDirectLaborWeeklyTotalRow({
  employeeDetails,
  weekColumns,
  staticColumns,
  type,
}) {
  return (
    <tr className="totalRow">
      {staticColumns.map((column) => (
        <td
          key={column.label}
          style={{ minWidth: column.width[type], maxWidth: column.width[type] }}
        />
      ))}
      {weekColumns.map((week, index) => {
        const totalHours = employeeDetails.reduce((sum, employee) => {
          const bucket = getBucketForWeek(employee, week.weekStartDate);
          return sum + (bucket ? Number(bucket.hours) || 0 : 0);
        }, 0);
        const totalBurdenCost = employeeDetails.reduce((sum, employee) => {
          const bucket = getBucketForWeek(employee, week.weekStartDate);
          return sum + (bucket ? round2(Number(bucket.burdenCost) || 0) : 0);
        }, 0);
        const isLastWeek = index === weekColumns.length - 1;
        return (
          <React.Fragment key={week.weekStartDate}>
            <td
              style={{
                minWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.costRate,
                maxWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.costRate,
                borderLeft: "1px solid #ccc",
                paddingLeft: "4px",
              }}
            />
            <td
              style={{
                minWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.hours,
                maxWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.hours,
              }}
              title={formatCellValue(totalHours, "number")}
            >
              {formatCellValue(totalHours, "number")}
            </td>
            <td
              style={{
                minWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.burdenCost,
                maxWidth: WEEKLY_BUCKET_COLUMN_WIDTHS.burdenCost,
                ...(isLastWeek ? { borderRight: "1px solid #ccc" } : {}),
              }}
              title={formatCellValue(totalBurdenCost, "currency")}
            >
              {formatCellValue(totalBurdenCost, "currency")}
            </td>
          </React.Fragment>
        );
      })}
    </tr>
  );
}
